// Phase 2J: Vehicle utilization + recorded financial metrics.
import { api } from "./api";

export const RANGE_PRESETS = [
  { value: "this_month", label: "This month" },
  { value: "last_month", label: "Last month" },
  { value: "last_30d", label: "Last 30 days" },
  { value: "last_90d", label: "Last 90 days" },
];

export async function getVehiclePerformance(vehicleId, { range = "this_month", start, end } = {}) {
  const params = { range };
  if (range === "custom") { params.start = start; params.end = end; }
  const { data } = await api.get(`/vehicles/${vehicleId}/performance`, { params });
  return data;
}

export async function getFleetPerformance({ range = "this_month", start, end, sort = "utilization_desc" } = {}) {
  const params = { range, sort };
  if (range === "custom") { params.start = start; params.end = end; }
  const { data } = await api.get("/analytics/fleet", { params });
  return data;
}

export function fmtPct(rate) {
  if (rate === null || rate === undefined) return "-";
  return `${Math.round(rate * 100)}%`;
}

export function fmtPeso(n) {
  return `₱${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
